export const formatAccountIndex = (accountIndex: number) => `#${accountIndex + 1}`
